import { render, staticRenderFns } from "./SuccessorsTable.vue?vue&type=template&id=04ebeef4"
import script from "./SuccessorsTable.vue?vue&type=script&lang=js"
export * from "./SuccessorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports